import { Database } from './../database';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { NL_Subeler } from '../../models/NL_Subeler';



@Injectable()
export class BllSubeler extends Database {

    constructor() {
        super("NL_Subeler");

    }

    subeBilgisiGuncelle(guncellenecekElement: NL_Subeler) {
        return new Promise((res, err) => {
            this.execRawQueryWithParams("update NL_Subeler set SubeAdres = ? where ID = ?", [guncellenecekElement.SubeAdres, guncellenecekElement.ID]).then(a => {
                res(a);
            }).catch(x => {
                err(x);
            })
        })
    }
    subeEkle(SubeAdi: string, SubeAdres: string, defaultadres: number) {
        return new Promise((resolve, reject) => {
            var sube = new NL_Subeler();
            sube.SubeAdi = SubeAdi;
            sube.SubeAdres = SubeAdres;
            sube.VarsayilanMi = defaultadres;
            this.add(sube).then(a=>{
                resolve(a);
            }).catch(x=>{
                reject(x);
            })
        });
    }



}



// WEBPACK FOOTER //
// ./src/providers/bll/bll-subeler.ts